import Flash from "../../images/newDesign/flash.svg";

export const storeMockNew = [
    {
        icon: Flash,
        title: 'nice handyman new',
        category: 'handyman',
        paragraphs: [
            'שיפוצים ואחזקה ברמה הגבוהה ביותר – כל הפתרונות לבית תחת קורת גג אחת!',
            'אנו מתמחים בשיפוצים, צביעה מקצועית, תיקונים כלליים, איטום נגד גשם, טיפול בעובש, אינסטלציה ועוד. השירות שלנו מותאם אישית לצרכים שלך, תוך דגש על איכות, אמינות ומקצועיות.',
            'בין אם זה שדרוג קטן או פרויקט שיפוץ רחב – אנחנו כאן כדי להפוך את הבית שלך למקום שתמיד חלמת עליו!',
            '✨ שירות אמין, מקצועי ומהיר – צרו קשר עוד היום! ✨',
        ],
        contactPhone: '0523685962',
        id: 'niceHandyMan',
    },
    {
        icon: Flash,
        title: 'מנורה ERN שכירות',
        category: 'insurance',
        paragraphs: [
            'אל תקחו סיכונים על הנכס שלכם! הצטרפו לשירות התחייבות לפרעון דמי השכירות.',
            'בדיקת דיירים חינמית',
            'מימון מלוא דמי השכירות שנה מראש',
            'שקט נפשי ויציבות כלכלית',
        ],
        contactLink: 'https://wordpress-420099-4609264.cloudwaysapps.com/%d7%91%d7%9c%d7%99%d7%a0%d7%a7-%d7%91%d7%a2%d7%9c%d7%99-%d7%93%d7%99%d7%a8%d7%94-%d7%97%d7%93%d7%a9/',
        id: 'MenoraRent',
    },
    {
        icon: Flash,
        title: 'אינסטלטור - עידן בן הרוש',
        category: 'plumber',
        paragraphs: [
            'פרטים - צילום קווי ביוב, איתור נזילות, פתיחת סתימות , קרסום שורשים, החלפת כלים סניטריים',
            'תיקון ניאגרות, סמויות, הגברת לחץ מים, תיקון דוד שמש',
            'אזורים: עתלית , טירת כרמל , חיפה , קריות , עכו , נהריה',
        ],
        contactPhone: '053-5535505',
        id: 'PlumberIdan',
    },
    {
        icon: Flash,
        title: 'אינסטלטור - אלירן שושן',
        category: 'plumber',
        paragraphs: [
            'אזורי פעילות: חיפה והסביבה, קריות, ישובי חוף כרמל עד עתלית כולל, טירת כרמל, נשר',
            'אינסטלטור אינסטלציה סנטרית תיקון נזילות פתירת בעיות אינסטלצייה, שירותי',
            'אינסטלצייה 24/7, תיקון והתקנת כל סוגי הברזים, פתיחת סתימות ביוב, הוצאת שורשים',
            'וקטילתם, דיפון ותיקון שוחות ביוב, העברת נקודות מים חדשות, תיקון והתקנת דודי שמש',
            'וחשמל, תיקון והתקנת טוחני אשפה, תיקון והתקנת ברי מים, תיקון והתקנת אביזרי סניטריה',
            'אינסטלצייה, תיקון נזילות וביצוע מעקפי צנרת, תיקון והתקנת ניאגרות ואסלות, תיקון אסלות',
            'סמויות ומנגנונים, התקנה מדיחים ומכונות כביסה'
        ],
        contactPhone: '0509663302',
        id: 'PlumberEliran',
    },
    {
        icon: Flash,
        title: 'רפאל עדו טכנאי מזגנים',
        category: 'air_conditioning_technician',
        paragraphs: [
            'תיקון מזגנים',
            'לא מבצע התקנות',
            'איזור השירות:',
            'תל אביב',
            'רמת גן',
            'גבעתיים',
            'סמויות ומנגנונים, התקנה מדיחים ומכונות כביסה'
        ],
        contactPhone: '0503019109',
        id: 'RaphaelIdoAirConditioner',
    },
    {
        icon: Flash,
        title: 'בריק פתרונות הדברה',
        category: 'exterminator',
        paragraphs: [
            'שירותי הדברת תיקנים,נמלים טרמיטים, פשפש מיטה, מכרסמים',
        ],
        contactPhone: '050-345-2551',
        id: 'BrickPestControl',
    },
    {
        icon: Flash,
        title: 'NG משכנתאות',
        category: 'mortgage_advisor',
        paragraphs: [
            'חברת יעוץ משכנתאות ותיקה עם ניסיון ומקצועיות ומאות לקוחות מרוצים',
            'אנו יודעים ללוות אתכם יד ביד בעסקה הכי חשובה שלכם בחיים ולדאוג לתנאי משכנתא הכי טובים במינימום זמן ומאמץ מבחינת הלקוח!',
            'אנו מתמחים במשכנתאות יד ראשונה, יד שניה, מחזור משכנתאות, איחוד הלוואות, מחיר למשתכן, משכנתאות לכל מטרה (שיפוץ וכו\'), עזרה לילדים, משכנתאות הפוכות, בניה עצמית ועוד..',
            'ברשותנו מספר מוצרים שיכולים להתאים עבור כל אחד לפי הצרכים שלו',
            'אנו מציעים לכם שיחת יעוץ ראשונה  - ללא עלות וללא התחייבות !',
            'אזורי פעילות - המשרדים ממוקמים במרכז אבל אנחנו עובדים בכל הארץ (וגם לא בארץ! עם תושבי חוץ)'


        ],
        contactPhone: '054-6606115',
        id: 'NgMortage',
    },
    {
        icon: Flash,
        title: 'ביטוח תכולה לדירה',
        category: 'insurance',
        paragraphs: [
            'הדירה שלך. הביטחון שלך. השקט שלך',
            'כדייר של בלינק, הדירה שלך היא המקום שבו אתה מרגיש בטוח. אבל מה קורה כשמשהו בלתי צפוי קורה?',
            'אנחנו כאן כדי לוודא שגם ברגעים כאלה, יש לך שקט נפשי.',
            '✅ ביטוח מותאם אישית לנכס שלך: משריפה ועד נזקי מים – ניתן יחד מענה להכל.',
            '✅ שירות אנושי ומהיר: אנחנו כאן כשאתה צריך אותנו.',
            '✅ מחיר הוגן ונגיש: ביטוח בלי לקרוע את הכיס.',
            '',
            'לחיצה אחת תקרב אותך לשקט נפשי',
            'לחיצה תוביל לשיחה קצרה בוואסטפ – בלי התחייבות ובלי דאגות.',
            '👉 לחץ כאן לשיחה איתנו בווטסאפ',
            'https://bit.ly/3PTq1Ao'
        ],
        contactPhone: '0548889889',
        id: 'G4UApartmentInsurance',
    },

]

export const storeCategories = [
    'handyman',
    'insurance',
    'plumber',
    'air_conditioning_technician',
    'exterminator',
    'mortgage_advisor'
];
